<template>
    <div
        :style="style"
        class="rkm-sidebar"
    >
        <div class="rkm-sidebar-wrap">
            <slot />
        </div>
    </div>
</template>

<script>
export default {
    computed: {
        style() {
            return {
                transform: this.open ? 'translateX(0%)' : 'translateX(-100%)',
            }
        },
    },
    props: {
        open: {type: Boolean},
    },
}
</script>

<style scoped>
.rkm-sidebar {
    background-color: #ffffff;
    box-shadow: 0px 0px 10px -5px #000;
    display: flex;
    flex-direction: column;
    height: 100vh;
    padding: 5px;
    pointer-events: auto;
    position: fixed;
    top: 56px;
    transition-duration: 0.2s;
    transition-property: transform, visibility, width;
    transition-timing-function: cubic-bezier(.4, 0, .2, 1);
    width: 256px;
    z-index: 902;
}
.rkm-sidebar-wrap {
    display: flex;
    flex-direction: column;
    height: calc(100% - 56px);
    justify-content: space-between;
    overflow: auto;
}
.rkm-sidebar-wrap::-webkit-scrollbar{
    background: transparent;
    width: 5px;
}
.rkm-sidebar-wrap::-webkit-scrollbar-track{
    background: none;
    box-shadow: none;
}
.rkm-sidebar-wrap::-webkit-scrollbar-thumb{
    background: rgba(0,0,0,0.3);
    border-radius: 10px;
}
</style>